/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Modal } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';

interface PropsType {
	enums?: any;
	value?: any;
	thumbSrc?: any;
  style?: React.CSSProperties;
}

const ShowVideo: React.FC<PropsType> = props => {
	const { value, thumbSrc, style } = props;

	const [previewOpen, setPreviewOpen] = useState(false);
	const [previewVideoUrl, setPreviewVideoUrl] = useState('');

	const handleCancel = () => setPreviewOpen(false);

	const preview = () => {
		setPreviewVideoUrl(value || '');
		setPreviewOpen(true);
	};

	return (
		<div
			style={{
        ...{
          width: '102px',
          height: '102px',
          border: '1px dashed #d4d4d4',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f9f9f9',
          position: 'relative'
        },
        ...style
      }}
		>
			{thumbSrc && <img style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }} src={thumbSrc} alt=''></img>}
			{!thumbSrc && <video controls={false} style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }} src={value} ></video>}
			<PlayCircleOutlined style={{ fontSize: '30px', color: '#d4d4d4', cursor: 'pointer', zIndex: 1 }} onClick={preview} />
      {
        previewOpen && <Modal open={previewOpen} title="预览" width="60%" footer={null} onCancel={handleCancel} centered>
          {previewVideoUrl && (
            <video style={{ maxHeight: '60vh' }} width="100%" controls>
              <source src={previewVideoUrl} type="video/mp4" />
              您的浏览器不支持视频标签。
            </video>
          )}
        </Modal>
      }
		</div>
	);
};

export default ShowVideo;
